






import Vue from 'vue';

import PublicPacket from '@/views/authenticated/PublicPacket.vue';
import OrganizationLoadGuard from '@/components/OrganizationLoadGuard.vue';

export default Vue.extend({
  components: {
    PublicPacket,
    OrganizationLoadGuard
  },

  props: {
    organizationId: Number,
    packetId: Number
  }
});
